<template>
    <div class="fee-summary w-100 display-flex mt-sm">
        <AonCol v-for="item in feeSummaryData" class="grid-cols-6 pr-xs">
            <AonCard :title="item?.title">
                <div class="card-content">
                    <p
                        v-if="item.filterRange"
                        class="small link filter-link"
                        @click="sendFilters(item.prune)"
                    >
                        View Patents
                    </p>
                    <h4 :class="`text-${item?.color}`">
                        {{ item?.color === 'error' ? '-' : '' }}${{ item?.value.toLocaleString() }}
                    </h4>
                    <p class="font-bold small mt-sm">{{ item?.scope }}</p>
                </div>
            </AonCard>
        </AonCol>
        <AonCol class="grid-cols-6 pl-xs">
            <AonCard title="Estimated Fees Pruned">
                <div class="card-content">
                    <p class="small link filter-link" @click="sendFilters(true)">View Patents</p>
                    <div class="display-inline-flex">
                        <h4 :class="`text-success`">
                            ${{ (props.data.totalFeesPruned ?? 0).toLocaleString() }}
                        </h4>
                        <p class="font-bold small ml-sm mt-xs">
                            {{
                                ` savings between ${filters.toUTCString(portfolioManagerStore.dateRange[0])} and ${filters.toUTCString(portfolioManagerStore.dateRange[1])}`
                            }}
                        </p>
                    </div>
                    <br />
                    <div class="display-inline-flex mt-xs">
                        <h4 :class="`text-success`">
                            ${{ (props.data.futureSavings ?? 0).toLocaleString() }}
                        </h4>
                        <p class="font-bold small ml-sm mt-xs">
                            {{
                                ` future savings after ${filters.toUTCString(portfolioManagerStore.dateRange[1])}`
                            }}
                        </p>
                    </div>
                </div>
            </AonCard>
        </AonCol>
    </div>
</template>

<script setup>
import { computed, inject, ref, watchEffect } from 'vue'
import { usePortfolioManagerStore } from '@/stores'

const portfolioManagerStore = usePortfolioManagerStore()

const filters = inject('filters')

const emit = defineEmits(['send-filters'])
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
})

const feeSummaryData = computed(() => {
    if (!props.data) return []
    return [
        {
            title: 'Estimated Upcoming Patent Fees',
            value: props.data.upcomingFees ?? 0,
            color: 'error',
            scope: `Due from ${filters.toUTCString(portfolioManagerStore.dateRange[0])} to ${filters.toUTCString(portfolioManagerStore.dateRange[1])}`,
            filterRange: true,
            prune: 'false',
        },
    ]
})

const sendFilters = (prune) => {
    emit('send-filters', {
        dateRange: {
            from: portfolioManagerStore.dateRange[0],
            to: portfolioManagerStore.dateRange[1],
        },
        prune: {
            value: prune, //string for ag-grid
        },
    })
}
</script>

<style lang="scss" scoped>
.fee-summary {
    width: 100%;

    .card-content {
        position: relative;
    }

    .filter-link {
        position: absolute;
        top: -40px;
        right: -0px;
    }
}
</style>
